import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DefaultErrorStateComponent } from '@app/infrastructure/state-switcher/components/default-error-state/default-error-state.component';
import { DefaultLoadingStateComponent } from '@app/infrastructure/state-switcher/components/default-loading-state/default-loading-state.component';
import { DefaultEmptyStateModule } from '@app/infrastructure/state-switcher/components/default-empty-state/default-empty-state.module';
import { EmptyStateDirective } from '@app/infrastructure/state-switcher/directives/empty-state.directive';
import { ErrorStateDirective } from '@app/infrastructure/state-switcher/directives/error-state.directive';
import { LoadingStateDirective } from '@app/infrastructure/state-switcher/directives/loading-state-directive';
import { WidgetStateAdapterPipe } from '@app/infrastructure/state-switcher/pipes/widget-state-adapter.pipe';
import { StateSwitcherComponent } from '@app/infrastructure/state-switcher/state-switcher.component';

@NgModule({
	declarations: [
		StateSwitcherComponent,
		DefaultLoadingStateComponent,
		DefaultErrorStateComponent,
		WidgetStateAdapterPipe,
		LoadingStateDirective,
		ErrorStateDirective,
		EmptyStateDirective,
	],
	imports: [CommonModule, DefaultEmptyStateModule],
	exports: [
		StateSwitcherComponent,
		WidgetStateAdapterPipe,
		EmptyStateDirective,
		ErrorStateDirective,
		LoadingStateDirective,
		DefaultLoadingStateComponent,
	],
})
export class StateSwitcherModule {}
